export interface IGetComboboxRewardSetup {
  skip: number;
  take: number;
  id?: string;
  type?: string;
}

export interface IGetComboboxGroupRoleManagement {
  skip: number;
  take: number;
  rewardId?: string;
  plantId?: string;
}

export interface ICreateRewardSetup {
  id: string;
  mainSetupId: string;
  type: string;
  supportYn: boolean;
  groupRoleManagement: string;
  groupRoleId: string;
  groupRoleName: string;
  condition: string;
  maxCondition: number;
  value: number;
  valueType: string;
}

export interface IUpdateRewardSetup extends ICreateRewardSetup {
  id: string;
  note: string;
}

export interface IUpdateRewardSeqment {
  id: string;
  useYn: boolean;
}

export interface IUpdateRewardSeqmentById {
  id: string;
  fromCondition: number;
  fromPercent: number;
  toCondition: number;
  toPercent: number;
  rewardAmount: number;
}

export interface IGetListRewardCondition {
  page: number;
  page_size: number;
  id?: string;
  groupRoleManagement?: string;
  typeReward?: string;
  type?: any;
  headerRow?: any;
}

export interface IGetListRewardFrame {
  page: number;
  page_size: number;
  type?: any;
  headerRow?: any;
  rewardSetupId?: string;
}

export const CalculationSetupVariables = {
  getListRewardCondition: (params: IGetListRewardCondition) => {
    const { page, page_size, id, groupRoleManagement, typeReward } = params;
    return {
      skip: (page - 1) * page_size,
      take: page_size,
      input: {
        ...(id && {
          id: {
            equals: id.trim(),
          },
        }),
        groupRoleManagement: {
          contains: groupRoleManagement,
        },
        type: {
          equals: typeReward,
        },
      },
    };
  },
  getListRewardFrame: (params: IGetListRewardFrame) => {
    const { page, page_size, rewardSetupId } = params;
    return {
      skip: (page - 1) * page_size,
      take: page_size,
      input: {
        ...(rewardSetupId && {
          rewardSetupId: {
            equals: rewardSetupId,
          },
        }),
      },
    };
  },

  saveRewardCondition: (params: any) => {
    const {
      id,
      condition,
      grossProfit,
      grossProfitCalculate,
      maxCondition,
      maxConditionCaculate,
      realRevenue,
      realRevenueCalculate,
      note,
      value,
    } = params;
    return {
      input: {
        ...(id && { id }),
        ...(condition && { condition }),
        ...(grossProfit && { grossProfit }),
        ...(grossProfitCalculate && { grossProfitCalculate }),
        ...(maxCondition && { maxCondition }),
        ...(maxConditionCaculate && { maxConditionCaculate }),
        ...(realRevenue && { realRevenue }),
        ...(realRevenueCalculate && { realRevenueCalculate }),
        ...(note && { note }),
        ...(value && { value }),
      },
    };
  },

  saveRewardFrame: (params: any) => {
    const {
      id,
      dmsTypeId,
      fromCondition,
      fromPercent,
      groupId,
      jobTitleId,
      noteCondition,
      rewardsSegId,
      objectType,
      rewardAmount,
      rewardSetupId,
      targetTypeId,
      toCondition,
      toPercent,
      unitId1,
      unitId2,
      unitId3,
      unitId4,
      unitName1,
      unitName2,
      unitName3,
      unitName4,
    } = params;
    return {
      input: {
        ...(id && { id }),
        ...(dmsTypeId && { dmsTypeId }),
        ...(fromCondition && { fromCondition }),
        ...(fromPercent && { fromPercent }),
        ...(groupId && { groupId }),
        ...(jobTitleId && { jobTitleId }),
        ...(noteCondition && { noteCondition }),
        ...(rewardsSegId && { rewardsSegId }),
        ...(objectType && { objectType }),
        ...(rewardAmount && { rewardAmount }),
        ...(rewardSetupId && { rewardSetupId }),
        ...(targetTypeId && { targetTypeId }),
        ...(toCondition && { toCondition }),
        ...(toPercent && { toPercent }),
        ...(unitId1 && { unitId1 }),
        ...(unitId2 && { unitId2 }),
        ...(unitId3 && { unitId3 }),
        ...(unitId4 && { unitId4 }),
        ...(unitName1 && { unitName1 }),
        ...(unitName2 && { unitName2 }),
        ...(unitName3 && { unitName3 }),
        ...(unitName4 && { unitName4 }),
      },
    };
  },
  getComboboxRewardSetup: ({
    id,
    skip,
    take,
    type,
  }: IGetComboboxRewardSetup) => {
    return {
      skip,
      take,
      input: {
        ...(id && { id: { contains: id } }),
        ...(type && { type: { equals: type } }),
      },
    };
  },
  getComboboxGroupRoleManagement: ({
    skip,
    take,
    rewardId,
    plantId,
  }: IGetComboboxGroupRoleManagement) => {
    return {
      skip,
      take,
      input: {
        ...(rewardId && { rewardId: { contains: rewardId } }),
        ...(plantId && { plantId: { equals: plantId } }),
      },
    };
  },
  createRewardSetup: (input: ICreateRewardSetup) => {
    return {
      input,
    };
  },

  updateRewardSetup: (input: IUpdateRewardSetup) => {
    return {
      input,
    };
  },

  updateRewardSeqmentStatus: (input: IUpdateRewardSeqment) => {
    return {
      input,
    };
  },

  updateRewardSeqmentById: (input: IUpdateRewardSeqmentById) => {
    return {
      input,
    };
  },
};
